import { useEffect, useState } from 'react';
import useUserStore from '@/stores/UserStore';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';

import { isUserAuthenticated } from '@/lib/utils';

// Function to check if a route is auth protected ad if the user is authenticated
export default function NonAuthLayout() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const user = useUserStore((state) => state.user);

  useEffect(() => {
    if (isUserAuthenticated() || user) {
      // Handle onboarding flow based on current and next stages
      if (user?.customer) {
        const { current_onboarding_stage, next_onboarding_stage } =
          user.customer;

        if (next_onboarding_stage === 'additional_details') {
          navigate('/onboarding/setup', { replace: true });
        } else if (next_onboarding_stage === 'connect_account') {
          navigate('/onboarding/connect-channel', { replace: true });
        } else if (next_onboarding_stage === 'pending_selection') {
          navigate('/onboarding/instagram/select-page', { replace: true });
        } else if (
          current_onboarding_stage === 'onboarded' &&
          next_onboarding_stage === null
        ) {
          // User is fully onboarded, continue with normal flow
          navigate('/inbox', { replace: true });
        } else {
          // Default fallback to inbox
          navigate('/inbox', { replace: true });
        }
      } else {
        // If no user data yet, default to inbox
        navigate('/inbox', { replace: true });
      }
    }
    setLoading(false);
  }, [user, navigate]);

  return loading ? null : <Outlet />;
}
